<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="转货单号:">
          <el-input v-model="formData.changeNo" placeholder="请输入转货单号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="审核日期:">
          <div style="display: flex;">
            <el-date-picker v-model="formData.dateStart" size="mini" type="date" placeholder="请选择审核日期" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
            -
            <el-date-picker v-model="formData.dateEnd" size="mini" type="date" placeholder="请选择审核日期" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="原一级货主:">
          <el-select
          v-model="formData.oldPrimaryCustomerTaxId"
          size="mini"
          filterable
          placeholder="请选择原一级货主"
          clearable
          >
            <el-option
            v-for="(item,index) in SHData"
            :key="index"
            :label="item.custerName"
            :value="item.taxpayerNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原二级货主:">
          <el-select
          v-model="formData.oldCustomerTaxId"
          size="mini"
          filterable
          placeholder="请选择原二级货主"
          clearable
          >
            <el-option
            v-for="(item,index) in SHData"
            :key="index"
            :label="item.custerName"
            :value="item.taxpayerNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原货权方:">
          <el-select
          v-model="formData.ownerCustomerTaxId"
          size="mini"
          filterable
          placeholder="请选择货权方"
          clearable
          >
            <el-option
            v-for="(item,index) in HQData"
            :key="index"
            :label="item.custerName"
            :value="item.taxpayerNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核结果:">
          <el-select
          v-model="formData.changeStatus"
          size="mini"
          placeholder="请选择审核结果"
          clearable
          >
            <el-option
            v-for="item in SHjgData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select
          v-model="formData.productType"
          size="mini"
          placeholder="请选择货物类型"
          clearable
          >
            <el-option
            v-for="item in HwData"
            :key="item.item_no"
            :label="item.show_name"
            :value="item.item_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现一级货主:">
          <el-select
          v-model="formData.newPrimaryCustomerTaxId"
          size="mini"
          filterable
          placeholder="请选择现一级货主"
          clearable
          >
            <el-option
            v-for="(item,index) in SHData"
            :key="index"
            :label="item.custerName"
            :value="item.taxpayerNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现二级货主:">
          <el-select
          v-model="formData.newCustomerTaxId"
          size="mini"
          filterable
          placeholder="请选择现二级货主"
          clearable
          >
            <el-option
            v-for="(item,index) in SHData"
            :key="index"
            :label="item.custerName"
            :value="item.taxpayerNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据来源:">
          <el-select
          v-model="formData.source"
          size="mini"
          placeholder="请选择数据来源"
          clearable
          >
          <el-option
          v-for="item in SjData"
          :key="item.item_no"
          :label="item.show_name"
          :value="item.item_no"
          ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转货提单号:">
          <el-input
          v-model="formData.changeBillNo"
          placeholder="请输入转货提单号"
          size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="转货外部单号:">
          <el-input v-model="formData.transferExternalNo" placeholder="请输入转货外部单号" size="mini"></el-input>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button
          type="primary"
          size="mini"
          @click="chaxun"
          btnCode="003P01GB001"
          v-if="btnFlg[0]"
          >查询</el-button>
          <el-button
          type="primary"
          size="mini"
          @click="chongzhi"
          btnCode="003P01GB002"
          v-if="btnFlg[1]"
          >重置</el-button>
          <el-button
          type="primary"
          size="mini"
          @click="daochu"
          btnCode="003P01GB003"
          v-if="btnFlg[2]"
          >导出</el-button>
          <el-button type="primary" v-if="btnFlg[3]" @click="churudanFN(1)"   >出库单</el-button>
          <el-button type="primary" v-if="btnFlg[4]" @click="churudanFN(2)"  >入库单</el-button>
          <el-button type="primary" v-if="btnFlg[5]" size="mini" @click="eidtWBDHfn"   >修改外部单号</el-button>
        </el-form-item>
        <span style="margin: 5px 10px">
          <span>总吨数:
            <span style="color:red">{{Number(allWeight).toFixed(3) }}</span>吨
          </span>
          <span>总件数:
            <span style="color:red">{{ allPoundWeight }}</span>件
          </span>
        </span>
      </el-form>
    </div>
    <div :style="{ height: h }">
      <el-table height="100%" highlight-current-row @row-click="handleRowClick" style="width:100%"
        size="mini" :data="detailsData" :header-cell-style="{ background: '#F5F5F5',color: 'black',}" border center bordersize="mini" class="tableComent">
        <!-- <el-table-column
        prop="changeId"
        label="转货单号"
        align="center"
        width="120"
        ></el-table-column> -->
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="danju"
          label="操作"
          align="center"
          width="150"
        >
        <template slot-scope="scope">
          <div>
            <el-button
            type="text"
            size="small"
            @click="handleClick(scope.row)"
            >查看单据</el-button>
          </div>
        </template>
          <!-- <el-image
            v-for="(item,index) in imgList.loadingImgs" :src="item.fileUrlOSS" :key="index"
            style="width: 260px; height: 200px"
            :preview-src-list="getSrcList(index,loadingImgs)">
          </el-image> -->
        </el-table-column>
        <el-table-column
        prop="approverDate"
        label="审核时间"
        align="center"
        :formatter="dateTimeFormat1"
        :show-overflow-tooltip="true"
        width="200"
        ></el-table-column>
        <el-table-column
        prop="oldPrimaryCustomerName"
        :show-overflow-tooltip="true"
        label="原一级货主"
        align="center"
        width="250"
        ></el-table-column>
        <el-table-column
        prop="oldSecondaryCustomerName"
        :show-overflow-tooltip="true"
        label="原二级货主"
        align="center"
        width="250"
        ></el-table-column>
        <el-table-column prop="oldOwnerCustomerName" label="原货权方" width="250" ></el-table-column>
        <el-table-column
          prop="newPrimaryCustomerName"
          :show-overflow-tooltip="true"
          label="现一级货主"
          align="center"
          width="250"
        ></el-table-column>
        <el-table-column
        prop="newSecondaryCustomerName"
              :show-overflow-tooltip="true"
        label="现二级货主"
        align="center"
        width="250"
        ></el-table-column>
        <el-table-column
        prop="productTypeName"
        :show-overflow-tooltip="true"
        label="货物类型"
        align="center"
        width="120"
        ></el-table-column>
        <el-table-column
        prop="steelMillName"
        :show-overflow-tooltip="true"
        label="产地"
        align="center"
        width="250"
        ></el-table-column>
        <el-table-column
        prop="specification"
        label="规格"
        align="center"
        width="120"
        ></el-table-column>
        <el-table-column
        prop="model"
        label="材质"
        align="center"
        width="120"
        ></el-table-column>
        <el-table-column
        prop="number"
        label="件数"
        align="center"
        width="120"
              :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
        prop="allWeight"
        label="总重量(吨)"
        align="center"
        width="120"
        >
          <template slot-scope="scope"><div>
          <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
          <span v-else>{{Number(scope.row.allWeight).toFixed(3)}}</span>
        </div></template>
        </el-table-column>
        <el-table-column
        prop="weight"
        label="理重(吨)"
        align="center"
        width="120"
        >
          <template slot-scope="scope"><div>
          <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
          <span v-else>{{Number(scope.row.weight).toFixed(3)}}</span>
        </div></template>
        </el-table-column>
        <el-table-column
          prop="weighingWeight"
          label="过磅净重(吨)"
          align="center"
          width="120"
        >
          <template slot-scope="scope"><div>
          <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
          <span v-else>{{Number(scope.row.weighingWeight).toFixed(3)}}</span>
        </div></template>
        </el-table-column>
        <el-table-column
          prop="weighingDate"
          label="净重过磅时间"
          align="center"
          :formatter="dateTimeFormat1"
          :show-overflow-tooltip="true"
          width="200"
        >
        </el-table-column>
        <el-table-column prop="chargMethod" label="收费方式" align="center" width="150"></el-table-column>

        <el-table-column
        prop="sourceName"
        label="数据来源"
        align="center"
        width="120"
        ></el-table-column>
        <el-table-column
        prop="changeBillNo"
        label="转货提单号"
        :show-overflow-tooltip="true"
        align="center"
        width="250"
        ></el-table-column>
        <el-table-column
        prop="changeNo"
        label="转货单号"
        align="center"
        width="250"
        :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferExternalNo" label="转货外部单号" align="center"
        width="200"></el-table-column>
        <el-table-column
        prop="applicantName"
        label="申请人"
        :show-overflow-tooltip="true"
        align="center"
        width="200"
        ></el-table-column>
        <el-table-column
        prop="approverName"
        label="审核人"
        align="center"
              :show-overflow-tooltip="true"
        width="200"
        ></el-table-column>
        <el-table-column
        prop="changeStatus"
        label="审核结果"
              :show-overflow-tooltip="true"
        align="center"
        width="120"
        ></el-table-column>
        <el-table-column
        prop="approverReject"
        label="审核意见"
        align="center"
        width="120"
        >
          <template v-slot="scope">
            <div>
              <el-button
              type="text"
              size="small"
              @click="chakanshenhe(scope.row)"
              >查看</el-button>
          </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="applicantDate"
          :show-overflow-tooltip="true"
          label="转货时间"
          align="center"
          width="200"
          :formatter="dateTimeFormat1"
        ></el-table-column>

      </el-table>
    </div>
    <!-- 分页-->
    <div class="pags" >
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        :page-sizes="[10,20,30,40,50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 查看单据 -->
    <el-dialog title="查看凭证" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="80%" center>
      <div class="img_box" v-if="!imgFlag">
        <div>暂未上传凭证</div>
      </div>
      <div class="box1" v-else>
        <div class="leftbox img_box">
          <div v-for="(item,index) in imgData" :key="index" @click="handChange(item.url,item.urlPrimary)" class="imgbox">
            <div v-if="item.urlPrimary.substring(item.urlPrimary.length-3)==='pdf'" >
              <img src="@/assets/images/pdf.jpg">
              <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i> -->
            </div>
            <div v-else>
              <img :src="item.url" alt />
              <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i> -->
            </div>
          </div>
        </div>
        <div class="rightbox">
          <div v-if="pdfFlag" class="pdfbox">
            <iframe :src="path" frameborder="0" style="width: 100%; height:100%" ></iframe>
          </div>
          <div class="imgDialog" v-else>
            <img :src="path" alt />
          </div>
        </div>
      </div>
      <div style="width:80px;margin:15px auto;">
        <el-button type="primary" @click="lookQuXiao">取消</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="查看现场图片" :visible.sync="dialogVisibleImg" width="35%">
    <div class="demo-image__preview"  v-if="!lookFlag" style="display: flex">
      <el-image
        :preview-src-list="getSrcList()"
        fit="cover"
        v-for="(item, index) in imgList"
        :key="index"
        style="
          width: 100px;
          height: 100px;
          display: block;
          margin-left: 5px;
        "
        :src="item"
      >
      </el-image>
    </div>
    <span v-if="lookFlag">暂无图片</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleImg = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisibleImg = false"
        >确 定</el-button>
    </span>
  </el-dialog> -->
    <!-- 审核意见 -->
    <el-dialog title="查看审核意见" :visible.sync="dialogShenheVisible" width="35%">
      <div class="demo-image__preview"  v-if="!lookApproverReject" style="display: flex">
        {{shenheYijian}}
      </div>
      <span v-if="lookApproverReject">暂无审核意见</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShenheVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="dialogVisibleImg = false"
          >确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 修改外部单号 -->
    <el-dialog title="修改外部单号" :visible.sync="dialogWBDH" :close-on-click-modal="false" @close="dialogWBDH = false"
      width="40%" center>
      <!--form表单-->
      <el-form :model="wbdhForm" ref="wbdhForm" label-width="120px" class="demo-dynamic"
        style="width:350px;margin:30px auto;">
        <el-form-item prop="transferExternalNo" label="转货外部单号" :rules="[
            {
              required: true,
              message: '请输入转货外部单号',
              trigger: 'blur',
            }
          ]">
          <el-input v-model="wbdhForm.transferExternalNo" size="mini" style="width: 200px"
              type="text" :maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div style="width:160px;margin:15px auto;">
        <el-button @click="dialogWBDH = false">取 消</el-button>
        <el-button type="primary" @click="wbdhSaveFn()" :loading="addLoad">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 出库单、入库单 -->
    <el-dialog :title="ischu?'出库单':'入库单'" :visible.sync="dialogCKD" :close-on-click-modal="false" @close="dialogCKD = false" width="300px" center>
      <div v-if="ischu" style="text-align: center;">
        <el-button type="primary" @click="daochuFN(1)">导出出库单</el-button>
        <el-button type="primary" @click="dayinFN(1)">打印出库单</el-button>
      </div>
      <div v-else style=" text-align: center;">
        <el-button type="primary" @click="daochuFN(2)">导出入库单</el-button>
        <el-button type="primary" @click="dayinFN(2)">打印入库单</el-button>
      </div>
      <div style="margin:15px auto;text-align: center;">
        <el-button @click="dialogCKD = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  zidian,
  getEmptyChangeRecordList,
  getImgShow,
  getSBillFileUrl,
  updateTransferExternalNo,
  updateImage
} from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import {
  dateTimeFormat1
} from '@/utils/util'

export default {
  data () {
    return {
      dateTimeFormat1: dateTimeFormat1, // 列表时间格式化
      path: '',
      imgFlag: true,
      imgData: [],
      pdfFlag: false,
      addMarkLookBox: false,
      dialogVisibleImg: false,
      lookFlag: false,
      imgList: [],
      total: 0,
      formData: {
        changeNo: '',
        changeStatus: '',
        dateStart: '',
        dateEnd: '',
        oldPrimaryCustomerTaxId: '',
        oldCustomerTaxId: '',
        newPrimaryCustomerTaxId: '',
        newCustomerTaxId: '',
        productType: '',
        changeBillNo: '',
        transferExternalNo: '',
        source: '',
        ownerCustomerTaxId: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      SHData: [],
      HQData: [], // 货权方
      detailsData: [],
      SHjgData: [
        {
          value: 1,
          label: '同意'
        },
        {
          value: 2,
          label: '驳回'
        }
      ],
      HwData: [],
      ShData: [],
      SjData: [],
      btnArr: [
        '003P01GB001',
        '003P01GB002',
        '003P01GB003', '003M2Y0100', '003M2Y0200', '003M2Y0300'
      ],
      btnFlg: [],
      allWeight: 0,
      allPoundWeight: 0,
      h: '400px',
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      selectionData: null,
      dialogWBDH: false,
      wbdhForm: {},
      addLoad: false,
      dialogCKD: false,
      ischu: null
    }
  },
  methods: {
    churudanFN (n) {
      if (!this.selectionData) {
        this.$message.error('请选择一条要操作的数据')
        return
      }
      this.ischu = n == 1
      this.dialogCKD = true
    },
    // 修改外部单号
    eidtWBDHfn () {
      if (!this.selectionData) {
        this.$message.error('请选择一条要操作的数据')
        return
      }
      this.wbdhForm = {}
      this.wbdhForm.changeId = this.selectionData.changeId
      this.$set(this.wbdhForm, 'transferExternalNo', this.selectionData.transferExternalNo)
      this.dialogWBDH = true
    },
    wbdhSaveFn () {
      this.addLoad = true
      this.$refs.wbdhForm.validate((valid) => {
        if (valid) {
          updateTransferExternalNo(this.wbdhForm).then((res) => {
            this.dialogWBDH = false
            this.$message.success('修改成功')
            this.getEmptyChangeRecordLists()
            this.addLoad = false
          }).catch((err) => {
            this.$message.error(err.message)
            this.addLoad = false
          })
        } else {
          this.addLoad = false
        }
      })
    },
    // 导出出入库单
    daochuFN (n) {
      if (n == 1) {
        exportExcel(
          this.global.wmsStockName + '/tEmpty/exportZyChangeOutList', {
            changeId: this.selectionData.changeId
          },
          '出库单'
        )
      } else {
        exportExcel(
          this.global.wmsStockName + '/tEmpty/exportZyChangeInList', {
            changeId: this.selectionData.changeId
          },
          '入库单'
        )
      }
    },
    // 打印出入库单
    dayinFN (n) {
      if (!this.selectionData) {
        this.$message.error('请选择一条要操作的数据')
        return
      }
      if (n == 1) {
        this.$router.push({ name: 'ZHChuKuDan',
          query: {
            huozhu: this.selectionData.oldSecondaryCustomerName,
            shijian: this.selectionData.applicantDate,
            danhao: this.selectionData.changeNo,
            changeId: this.selectionData.changeId
          } })
      } else {
        this.$router.push({ name: 'ZHRuKuDan',
          query: {
            huozhu: this.selectionData.newPrimaryCustomerName,
            shijian: this.selectionData.applicantDate,
            danhao: this.selectionData.changeNo,
            changeId: this.selectionData.changeId
          } })
      }
    },
    // 点击选中
    handleRowClick (row) {
      this.selectionData = row
    },
    // 删除凭证
    // delImg (item) {
    //   this.$confirm('确定删除图片?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       updateImage({
    //         imgId: item.imgId // 变更图片表id
    //       })
    //         .then(res => {
    //           DonMessage.success('操作成功!')
    //           this.getImgShowB()
    //         })
    //         .catch(err => {
    //           DonMessage.error(err.message)
    //         })
    //     })
    //     .catch(() => {})
    // },
    // 查看凭证-取消
    lookQuXiao () {
      this.addMarkLookBox = false
    },
    // 查看凭证-放大
    handChange (url, urlPrimary) {
      console.log(url, 2)
      this.path = url
      let str = urlPrimary.substring(urlPrimary.length - 3)
      if (str === 'pdf') {
        this.pdfFlag = true
      } else {
        this.pdfFlag = false
      }
      console.log(str)
      // this.dialogVisible = true
    },
    chakanshenhe (row) {
      this.dialogShenheVisible = true
      this.shenheYijian = row.approverReject
    },
    // 点击凭证放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    },
    // 查看图片
    handleClick (row) {
      this.getImgShowB(row)
    },
    getImgShowB (row) {
      // let params = {
      //   businessId: this.turnGoodsTableList[0].stockSummaryId,
      //   businessType: 'empty_stock_summary'
      // }
      getImgShow(
        {
          businessId: row.changeId,
          businessType: 'empty_change'
        }
      )
        .then((res) => {
          console.log(res)
          this.imgData = []
          this.imgFlag = true
          if (res.length < 1) {
            this.imgFlag = false
            return
          }
          this.imgData = res
          // this.pdfFlag = false
          this.seen3 = false
          this.seen2 = true

          // this.imgList = []
          if (row.sourceName == '手动') {
            // this.dialogVisibleImg = true
            // this.lookFlag = false
            // res.forEach((item, index) => {
            //   this.imgList.push(item.url)
            // })
            this.addMarkLookBox = true

            if (this.imgData[0].urlPrimary.substring(this.imgData[0].urlPrimary.length - 3) === 'pdf') {
              this.pdfFlag = true
              // this.path=this.imgData[0].urlPrimary
            } else {
              this.pdfFlag = false
              // this.path=this.imgData[0].url
            }
            this.path = this.imgData[0].url
          } else {
            let formData = new FormData()
            formData.append('url', res[0].urlPrimary)
            getSBillFileUrl(formData).then(res => {
              this.$router.push({
                // 核心语句
                path: '/pdf', // 跳转的路径
                query: {
                  // 路由传参时push和query搭配使用 ，作用时传递参数
                  path: res
                }
              })
            })
          }

          // if (this.imgList.length == 0) {
          //   this.lookFlag = true
          // }
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 分页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getEmptyChangeRecordLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getEmptyChangeRecordLists()
    },
    chaxun () {
      this.getEmptyChangeRecordLists()
    },
    chongzhi () {
      this.formData.changeNo = ''
      this.formData.dateStart = ''
      this.formData.dateEnd = ''
      this.formData.oldPrimaryCustomerTaxId = ''
      this.formData.oldCustomerTaxId = ''
      this.formData.newPrimaryCustomerTaxId = ''
      this.formData.newCustomerTaxId = ''
      this.formData.productType = ''
      this.formData.changeBillNo = ''
      this.formData.transferExternalNo = ''
      this.formData.source = ''
      this.formData.changeStatus = ''
      this.formData.ownerCustomerTaxId = ''
      this.getEmptyChangeRecordLists()
    },
    // 导出
    daochu () {
      this.isDisableYH = true
      setTimeout(() => {
        this.isDisableYH = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
      let form = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        changeNo: this.formData.changeNo,
        dateStart: this.formData.dateStart,
        dateEnd: this.formData.dateEnd,
        oldPrimaryCustomerTaxId: this.formData.oldPrimaryCustomerTaxId,
        oldCustomerTaxId: this.formData.oldCustomerTaxId,
        newPrimaryCustomerTaxId: this.formData.newPrimaryCustomerTaxId,
        newCustomerTaxId: this.formData.newCustomerTaxId,
        productType: this.formData.productTypeName,
        changeBillNo: this.formData.changeBillNo,
        transferExternalNo: this.formData.transferExternalNo,
        source: this.formData.source,
        changeStatus: this.formData.changeStatus,
        ownerCustomerTaxId: this.formData.ownerCustomerTaxId
      }
      // fetch(
      exportExcel(
        this.global.wmsStockName +
          '/tEmpty/exportEmptyChangeRecordList',
        form,
        '转货记录信息表'
      )
    },
    // 列表
    getEmptyChangeRecordLists () {
      getEmptyChangeRecordList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        changeNo: this.formData.changeNo,
        dateStart: this.formData.dateStart,
        dateEnd: this.formData.dateEnd,
        oldPrimaryCustomerTaxId: this.formData.oldPrimaryCustomerTaxId,
        oldCustomerTaxId: this.formData.oldCustomerTaxId,
        newPrimaryCustomerTaxId: this.formData.newPrimaryCustomerTaxId,
        newCustomerTaxId: this.formData.newCustomerTaxId,
        productType: this.formData.productType,
        changeBillNo: this.formData.changeBillNo,
        transferExternalNo: this.formData.transferExternalNo,
        source: this.formData.source,
        changeStatus: this.formData.changeStatus,
        ownerCustomerTaxId: this.formData.ownerCustomerTaxId
      })
        .then(res => {
          console.log(res)
          this.detailsData = res.pageInfo.list
          if (res.pageInfo.list.length == 0) {
            this.allWeight = 0
            this.allPoundWeight = 0
          } else {
            this.allWeight = res.all.allWeight
            this.allPoundWeight = res.all.allNumber
          }
          this.total = res.pageInfo.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.SHData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({ 'custerName': '无货权方', 'taxpayerNumber': '-1' })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          // console.log(res)
          this.HwData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    zidiansj () {
      zidian({
        groupNo: 'source'
      })
        .then((res) => {
          // console.log(res)
          this.SjData = res
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/transferRecord')
    this.getEmptyChangeRecordLists()
    this.getRelationCustomerS()
    this.zidians()
    this.zidiansj()
    // this.changeExamines()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.box1{
  overflow: hidden;
}
.leftbox{
  width:250px;
  float:left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y:auto;
  // height:150px;
  // background-color:red;
  // .imgbox{
  //   border-bottom: 1px solid #ccc;
  // }

}
.rightbox{
  margin-left:50px;
  width:850px;
  float:left;
  // height:150px;
  // background-color:yellow;
  .pdfbox{
    height:  calc(100vh - 250px);
  }
}
.img_box {
  // width: 100%;
  // display: flex;
  // flex-direction: row;
  // align-items: flex-start;
  // flex-wrap: wrap;
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    // border: 1px dashed #ccc;
    // border-radius: 10px;
    padding: 2px;
    img {
      width: 150px;
      height: 150px;
      margin-left:50px;
    }
  }
}
.imgDialog {
  width: 100%;
  // height:60vh;
  // overflow-x: scroll;
  // overflow-y: scroll;
  text-align: center;
  img {
    height:  calc(100vh - 250px);
    // background-size: 100% 100%;
  }
}
</style>
